import { fromJS } from 'immutable';
import { VALUE_CHANGED, LOAD, NEXT, RESET, REPORT_TO } from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    areYouClaimingForSnowSportsOptionalCover: 'false',
    areYouClaimingForSnowSportEquipment: 'false',
    areYouClaimingForSnowEquipmentReplacementHire: 'false',
    areYouClaimingForSnowPrepaidExpenses: 'false',
    areYouClaimingForSnowResortClosure: 'false',
    snowSportEquipment: {
      howItHappened: '',
      whereYouWereInRelationToTheItem: '',
      additional: '',
      claimingFor: {
        loss: null,
        theft: null,
        damage: null,
        delay: null,
      },
      whoDidYouReportThisTo: REPORT_TO.NOT_REPORT,
      otherDescription: '',
      reportReferenceNumber: '',
    },
    snowEquipmentReplacementHire: {
      howItHappened: '',
      whereYouWereInRelationToTheItem: '',
      additional: '',
      claimingFor: {
        loss: null,
        theft: null,
        damage: null,
        delay: null,
      },
      whoDidYouReportThisTo: REPORT_TO.NOT_REPORT,
      otherDescription: '',
      reportReferenceNumber: '',
    },
    patientName: '',
    relationshipToYou: '',
    patientDateOfBirth: '',
    medicareNumber: '',
    whatIsYourInjuryOrIllness: '',
    didThisOccurWhilstEngagingInSnowSportActivity: 'false',
    wasTheInjuredIllTravellerAnInpatient: 'false',
    snowPrepaidCancellationExpenses: [],
    snowResortCancellationExpenses: [],
    snowPrepaidAdditionalExpenses: [],
    snowResortAdditionalExpenses: [],
    snowSportEquipmentAdditionalItems: [],
    snowEquipmentReplacementHireAdditionalItems: [],
    areThereAnyAdditionalExpensesToBeClaimedSnowPrepaid: 'false',
    areThereAnyAdditionalExpensesToBeClaimedSnowResort: 'false',
  },
  errors: [],
});

const initialSnowSport = {
  form: {
    areYouClaimingForSnowSportEquipment: 'false',
    snowSportEquipment: {
      howItHappened: '',
      whereYouWereInRelationToTheItem: '',
      additional: '',
      claimingFor: {
        loss: null,
        theft: null,
        damage: null,
        delay: null,
      },
      whoDidYouReportThisTo: REPORT_TO.NOT_REPORT,
      otherDescription: '',
      reportReferenceNumber: '',
    },
    snowSportEquipmentAdditionalItems: [],
  },
};

const initialSnowEquipment = {
  form: {
    areYouClaimingForSnowEquipmentReplacementHire: 'false',
    snowEquipmentReplacementHire: {
      howItHappened: '',
      whereYouWereInRelationToTheItem: '',
      additional: '',
      claimingFor: {
        loss: null,
        theft: null,
        damage: null,
        delay: null,
      },
      whoDidYouReportThisTo: REPORT_TO.NOT_REPORT,
      otherDescription: '',
      reportReferenceNumber: '',
    },
    snowEquipmentReplacementHireAdditionalItems: [],
  },
};

const initialSnowPrepaid = {
  form: {
    areYouClaimingForSnowPrepaidExpenses: 'false',
    patientName: '',
    relationshipToYou: '',
    patientDateOfBirth: '',
    medicareNumber: '',
    whatIsYourInjuryOrIllness: '',
    didThisOccurWhilstEngagingInSnowSportActivity: 'false',
    wasTheInjuredIllTravellerAnInpatient: 'false',
    snowPrepaidCancellationExpenses: [],
    snowPrepaidAdditionalExpenses: [],
    areThereAnyAdditionalExpensesToBeClaimedSnowPrepaid: 'false',
  },
};

const initialSnowResort = {
  form: {
    areYouClaimingForSnowResortClosure: 'false',
    snowResortCancellationExpenses: [],
    snowResortAdditionalExpenses: [],
    areThereAnyAdditionalExpensesToBeClaimedSnowResort: 'false',
  },
};

function step10Reducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED: {
      if (
        properties[1] === 'areYouClaimingForSnowSportsOptionalCover' &&
        action.value === 'false'
      ) {
        return initialState;
      }
      if (
        properties[1] === 'areYouClaimingForSnowSportEquipment' &&
        action.value === 'false'
      ) {
        return state
          .setIn(['form', 'snowSportEquipmentAdditionalItems'], [])
          .mergeDeep(initialSnowSport);
      }
      if (
        properties[1] === 'areYouClaimingForSnowEquipmentReplacementHire' &&
        action.value === 'false'
      ) {
        return state
          .setIn(['form', 'snowEquipmentReplacementHireAdditionalItems'], [])
          .mergeDeep(initialSnowEquipment);
      }
      if (
        properties[1] === 'areYouClaimingForSnowResortClosure' &&
        action.value === 'false'
      ) {
        return state
          .setIn(['form', 'snowResortCancellationExpenses'], [])
          .setIn(['form', 'snowResortAdditionalExpenses'], [])
          .mergeDeep(initialSnowResort);
      }
      if (
        properties[1] === 'areYouClaimingForSnowPrepaidExpenses' &&
        action.value === 'false'
      ) {
        return state
          .setIn(['form', 'snowPrepaidCancellationExpenses'], [])
          .setIn(['form', 'snowPrepaidAdditionalExpenses'], [])
          .mergeDeep(initialSnowPrepaid);
      }
      return state.setIn(properties, action.value);
    }
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    default:
      return state;
  }
}

export default step10Reducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step10/reducer.js